module.exports = __webpack_public_path__ + "img/venues_sands_gallery.ec2a7d6c.jpg";